/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './nutrition-order-item.reducer';

export const NutritionOrderItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const nutritionOrderItemEntity = useAppSelector(state => state.nutritionOrderItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="nutritionOrderItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.nutritionOrderItem.detail.title">NutritionOrderItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.nutritionOrderItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{nutritionOrderItemEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.nutritionOrderItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{nutritionOrderItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.nutritionOrderItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{nutritionOrderItemEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.nutritionOrderItem.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{nutritionOrderItemEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.nutritionOrderItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{nutritionOrderItemEntity.microSec}</dd>
          <dt>
            <span id="total">
              <Translate contentKey="tinyMedicRestApp.nutritionOrderItem.total">Total</Translate>
            </span>
          </dt>
          <dd>{nutritionOrderItemEntity.total}</dd>
          <dt>
            <span id="rdi">
              <Translate contentKey="tinyMedicRestApp.nutritionOrderItem.rdi">Rdi</Translate>
            </span>
          </dt>
          <dd>{nutritionOrderItemEntity.rdi ? 'true' : 'false'}</dd>
          <dt>
            <span id="dailyTotal">
              <Translate contentKey="tinyMedicRestApp.nutritionOrderItem.dailyTotal">Daily Total</Translate>
            </span>
          </dt>
          <dd>{nutritionOrderItemEntity.dailyTotal}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.nutritionOrderItem.nutrition">Nutrition</Translate>
          </dt>
          <dd>{nutritionOrderItemEntity.nutrition ? nutritionOrderItemEntity.nutrition.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.nutritionOrderItem.order">Order</Translate>
          </dt>
          <dd>{nutritionOrderItemEntity.order ? nutritionOrderItemEntity.order.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/nutrition-order-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/nutrition-order-item/${nutritionOrderItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default NutritionOrderItemDetail;
